export const toActivity = '/actividad';
export const toActivityMessages = '/actividad/mensajes';
export const toMessage = '/mensajes/:id';
export const toMessageFunc = id => `/mensajes/${id}`;
